import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { useLocalStorage } from 'react-use'

import Button from '../../../../components/button'
import { SubscriptionModelPropTypes } from '../../../../schemas/subscription/model'
import { H5, S1, S05, Text } from '../../../../styles/typography'
import getCurrencySymbol from '../../../../utils/currency-symbol'
import subscriptionFeatures from '../config/features'
import PricingStore from '../stores/pricing-store'

const Plan = ({ data, filterNullValues }) => {
  const symbol = getCurrencySymbol(data.currency)
  const { existing, showMonthly } = PricingStore.useContainer()

  const [subscriptionCouponStorage] = useLocalStorage('subscription-coupon', '')

  const discount = useMemo(
    () =>
      (subscriptionCouponStorage === 'SUMMR22LIV' ||
        subscriptionCouponStorage === 'LEARNLIV23' ||
        subscriptionCouponStorage === 'MUSIC24LIVD') &&
      !showMonthly
        ? 50
        : 0,
    [showMonthly, subscriptionCouponStorage],
  )

  return (
    <div className='plan'>
      <div className='content'>
        <div className='header'>
          <H5>{data.name}</H5>
          {Boolean(discount) && (
            <S1 style={{ textDecoration: 'line-through' }}>
              {symbol}
              {data.amount}/{showMonthly ? `month` : `year`}
            </S1>
          )}
          <S05>
            {symbol}
            {Math.floor((data.amount * (100 - discount)) / 100)}/
            {showMonthly ? `month` : `year`}
          </S05>
        </div>

        {subscriptionFeatures.map(({ id, key, parser, condition }) => {
          const value = parser(key === 'all' ? data : data.features[key])

          return filterNullValues && !condition({ showMonthly }) ? null : (
            <div key={id} className='row'>
              {typeof value === 'string' || typeof value === 'number' ? (
                !value ? (
                  <ClearIcon />
                ) : (
                  <Text>{value}</Text>
                )
              ) : value ? (
                <CheckIcon />
              ) : (
                <ClearIcon />
              )}
            </div>
          )
        })}
        <div className='footer'>
          <Link href={`/pricing/payment/${data?.id}`} passHref>
            <a
              style={
                existing?.id
                  ? { filter: 'saturate(0)', pointerEvents: 'none' }
                  : {}
              }
            >
              <Button onClick={async () => {}} theme='primary'>
                Purchase
              </Button>
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Plan

Plan.propTypes = {
  data: SubscriptionModelPropTypes.isRequired,
  filterNullValues: PropTypes.bool,
}

Plan.defaultProps = {
  filterNullValues: false,
}
